/**
 * R24 · Interaktions-Schicht: Scroll-Fortschritt, Druck-/Warte-Zustand, Ziehen
 *
 * Ausgelagert aus snippets/r24-interactions.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function(){
  /* ── Scroll-Fortschritt ─────────────────────────────────────────────── */
  var bar = document.createElement('div');
  bar.className = 'r24x-prog';
  bar.setAttribute('aria-hidden','true');
  (document.body || document.documentElement).appendChild(bar);
  var ticking = false;
  function progress(){
    var d = document.documentElement;
    var max = (d.scrollHeight - d.clientHeight);
    var p = max > 40 ? Math.min(1, Math.max(0, (window.scrollY || d.scrollTop) / max)) : 0;
    bar.style.transform = 'scaleX(' + p + ')';
    bar.classList.toggle('is-on', max > 40 && p > 0.004);
    ticking = false;
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(progress); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  progress();

  /* ── Warte-Zustand beim Absenden eines Formulars ─────────────────────── */
  document.addEventListener('submit', function(e){
    var f = e.target; if(!f || f.getAttribute('data-r24x-nobusy') === '1') return;
    var btn = f.querySelector('button[type="submit"],input[type="submit"]');
    if(btn && !btn.disabled){
      btn.classList.add('r24x-busy');
      /* Falls die Navigation ausbleibt (Validierungsfehler), Zustand zurücknehmen. */
      setTimeout(function(){ btn.classList.remove('r24x-busy'); }, 6000);
    }
  }, true);

  /* ── Ziehbare Reihen: Maus/Stift ziehen wie auf dem Touchscreen ──────── */
  var RAILS = '[data-r24-serie-row],[class*="reco-grid"],.r24pp__grid,.r24mag,.r24sr-rail,[data-r24x-drag]';
  function initRail(el){
    if(el.__r24x) return; el.__r24x = 1;
    var style = window.getComputedStyle(el);
    if(style.overflowX !== 'auto' && style.overflowX !== 'scroll') return;
    el.classList.add('r24x-drag');
    if(el.parentElement && !el.parentElement.classList.contains('r24x-dragwrap')){
      el.parentElement.classList.add('r24x-dragwrap');
    }
    function more(){
      var p = el.parentElement;
      if(p) p.classList.toggle('has--more', el.scrollWidth - el.clientWidth - el.scrollLeft > 8);
    }
    el.addEventListener('scroll', more, {passive:true});
    window.addEventListener('resize', more);
    more(); setTimeout(more, 500);

    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('pointerdown', function(ev){
      if(ev.pointerType === 'touch') return;          /* Touch scrollt nativ */
      if(ev.button !== 0) return;
      down = true; moved = false; startX = ev.clientX; startLeft = el.scrollLeft;
    });
    el.addEventListener('pointermove', function(ev){
      if(!down) return;
      var dx = ev.clientX - startX;
      if(!moved && Math.abs(dx) < 5) return;          /* Schwelle → Klicks bleiben Klicks */
      if(!moved){ moved = true; el.classList.add('is-dragging'); try{ el.setPointerCapture(ev.pointerId); }catch(_){} }
      el.scrollLeft = startLeft - dx;
      ev.preventDefault();
    });
    /* `moved` wurde bisher NUR im click-Handler zurückgesetzt. Endete ein Zug ausserhalb
       der Reihe (pointerleave/pointercancel), folgte kein Klick — das Flag blieb stehen und
       verschluckte den NÄCHSTEN echten Klick auf ein Produkt. Jetzt räumt jedes Ende auf,
       aber erst im nächsten Task: der unmittelbar folgende click (nach pointerup) sieht das
       Flag noch und wird korrekt unterdrückt. */
    function end(){
      if(!down) return;
      down = false; el.classList.remove('is-dragging');
      setTimeout(function(){ moved = false; }, 0);
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', end);
    /* Ein echter Zieh-Vorgang darf keinen Produktlink öffnen. */
    el.addEventListener('click', function(ev){ if(moved){ ev.preventDefault(); ev.stopPropagation(); moved = false; } }, true);
  }
  function scanRails(){ document.querySelectorAll(RAILS).forEach(initRail); }

  /* ── Auftauchen beim Scrollen: steht seit 23.09.2026 in assets/r24-motion.js (EIN
     geteiltes, gecachtes Skript mit defer; dort auch Produkt-Rails). Die CSS-Klasse
     .r24x-rv bleibt hier oben. ─────────────────────────────────────────────────── */

  /* Karussell-Pfeile per Event-Delegation (Handoff §8): ein Klick auf
     [data-arrow="<row-id>|<dir>"] scrollt [data-row="<row-id>"] um ±340px.
     Bestehende Pfeile mit eigener Logik bleiben unangetastet. */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-arrow]');
    if(!b) return;
    var parts = (b.getAttribute('data-arrow')||'').split('|');
    var row = document.querySelector('[data-row="'+parts[0]+'"]');
    if(!row) return;
    e.preventDefault();
    row.scrollBy({left: (parts[1] === 'prev' ? -340 : 340), behavior:'smooth'});
  }, true);

  function boot(){ scanRails(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  /* Nachgeladene Inhalte (Empfehlungen, Warenkorb-Updates) ebenfalls erfassen. */
  document.addEventListener('t4s:cart:updated', function(){ setTimeout(boot, 250); });
  document.addEventListener('cart:updated', function(){ setTimeout(boot, 250); });
})();
